"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentSubmittedDropdown = void 0;
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
// 학생 응시여부 필터: 미응시 / 응시완료 (서버 /api/mimac/v1/tests 의 submitted 필터)
//  - select        : 전체(필터 미적용)
//  - not_submitted : 미응시(submitted=false)
//  - submitted     : 응시완료(submitted=true)
const SUBMITTED_DROPDOWN_LIST = [
    { id: 'select', title: 'assignment.examStatus' },
    { id: 'not_submitted', title: 'assignment.noStare' },
    { id: 'submitted', title: 'assignment.stareCompleted' },
];
exports.AssignmentSubmittedDropdown = react_1.default.memo(({ submitted, setSubmitted }) => {
    const { isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [value, setValue] = react_1.default.useState(SUBMITTED_DROPDOWN_LIST[0]);
    react_1.default.useEffect(() => {
        if (submitted !== value.id) {
            setValue(SUBMITTED_DROPDOWN_LIST.find(item => item.id === submitted) || SUBMITTED_DROPDOWN_LIST[0]);
        }
    }, [submitted]);
    const handlerUpdateDrop = (item) => {
        setSubmitted(item.id);
        setValue(item);
    };
    return (react_1.default.createElement(common_1.DropDown, { className: "dropdown-tablet-small", value: value, list: SUBMITTED_DROPDOWN_LIST, styles: {
            ...(isMobile ? {} : { dropWrap: { width: isTablet ? 120 : 150 } }),
            itemWrap: {
                top: isTablet ? '50px' : '45px',
            },
        }, setDropValue: handlerUpdateDrop }));
});
